import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import DefaultLayoutView from './DefaultLayoutView';

export class DefaultLayoutContainer extends Component {
  render() {
    return (
      <DefaultLayoutView {...this.props} />
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth.user
  };
}

export default withRouter(connect(mapStateToProps)(DefaultLayoutContainer));



// WEBPACK FOOTER //
// ./src/app/layouts/default/DefaultLayoutContainer.js